'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import BaseCard from '@/components/BaseCard';
import CardAwards from '@/components/BaseCard/CardAwards';
import { CaseSlideItem } from '@/components/CasesChunkedSlider/types';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import { blocksContentToAltText } from '@/lib/blocks-content';
import css from './style.module.scss';
interface Props {
  caseItem: CaseSlideItem;
  className?: string;
  setIsCustomCursorVisible?: (value: boolean) => void;
}
const WorkCard: FC<Props> = t0 => {
  const $ = _c(26);
  const {
    caseItem,
    className,
    setIsCustomCursorVisible
  } = t0;
  let t1;
  if ($[0] !== setIsCustomCursorVisible) {
    t1 = () => {
      setIsCustomCursorVisible?.(true);
    };
    $[0] = setIsCustomCursorVisible;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onMouseEnter = t1;
  let t2;
  if ($[2] !== setIsCustomCursorVisible) {
    t2 = () => {
      setIsCustomCursorVisible?.(false);
    };
    $[2] = setIsCustomCursorVisible;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onMouseLeave = t2;
  const t3 = caseItem.url || "";
  let t4;
  if ($[4] !== className) {
    t4 = clsx(css.workCard, className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = caseItem.image?.url;
  let t6;
  if ($[6] !== caseItem.awards) {
    t6 = <CardAwards awards={caseItem.awards} />;
    $[6] = caseItem.awards;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== caseItem.image?.alternativeText || $[9] !== caseItem.subtitle || $[10] !== caseItem.title) {
    t7 = caseItem.image?.alternativeText || blocksContentToAltText(caseItem.title) || caseItem.subtitle;
    $[8] = caseItem.image?.alternativeText;
    $[9] = caseItem.subtitle;
    $[10] = caseItem.title;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== caseItem.title) {
    t8 = caseItem.title ? <Typography variant="h6" tag="h3" className={css.title}><StrapiRichContent content={caseItem.title} /></Typography> : null;
    $[12] = caseItem.title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== caseItem.subtitle || $[15] !== caseItem.thumbnailUrl || $[16] !== caseItem.videoUrl || $[17] !== onMouseEnter || $[18] !== onMouseLeave || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <BaseCard playing={true} url={t3} className={t4} subtitle={caseItem.subtitle} videoUrl={caseItem.videoUrl} thumbnailUrl={caseItem.thumbnailUrl} imageUrl={t5} withOverlay={false} awards={t6} imageAlt={t7} mainText={t8} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />;
    $[14] = caseItem.subtitle;
    $[15] = caseItem.thumbnailUrl;
    $[16] = caseItem.videoUrl;
    $[17] = onMouseEnter;
    $[18] = onMouseLeave;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
export default WorkCard;